<template>
  <div class="wizard__container">
    <img
      src="@/assets/img/logos/99icon_black.svg"
      :alt="appName"
      :title="appName"
      class="wizard__logo"
    >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Container',
  computed: {
    appName () {
      return process.env.VUE_APP_TITLE
    }
  }
}
</script>

<style lang="scss">
.wizard__container {
  background-color: $white;
  border: 1px solid $gray-2;
  border-radius: 4px;
  margin: 0 auto;
  max-width: 848px;
  padding: 68px 0 40px;
  position: relative;
}

.wizard__logo {
  left: 50%;
  position: absolute;
  top: -28px;
  transform: translateX(-50%);
  width: 48px;
}
</style>
